import type { ReactNode } from "react";
import "./OwnerPage.css";

/**
 * The one head every owner page opens with: the title at the page size, at the
 * same left edge as the column under it; at most one muted line of meta under
 * it; the page's primary action at the right. The top bar does not repeat the title.
 *
 * The head keeps one height, with or without meta or actions, so a page that
 * loads under it never moves it.
 */
export function PageHead({ title, meta, actions }: {
  title: string;
  /** One short line, in the muted small type. */
  meta?: ReactNode;
  /** The page's primary action, then its secondary ones. */
  actions?: ReactNode;
}) {
  return <header className="pa-head">
    <div className="pa-head-copy">
      <h1 className="pa-head-title">{title}</h1>
      {meta ? <p className="pa-head-meta">{meta}</p> : null}
    </div>
    {actions ? <div className="pa-head-actions">{actions}</div> : null}
  </header>;
}
